import React from 'react';
import EquipmentForm from '../../equipmentSurveys/components/EquipmentForm';
import {
  BasicInfo,
  CurrentPractices,
  ReplacementAssessment
} from './components/';
import { NewEquipment, PurchasingDecision } from '../components';

function FlameWeeding({ applicationData, setApplicationData }) {
  return (
    <EquipmentForm
      applicationData={applicationData}
      setApplicationData={setApplicationData}
    >
      <BasicInfo />
      <CurrentPractices />
      <ReplacementAssessment />
      <NewEquipment />
      <PurchasingDecision />
    </EquipmentForm>
  );
}

export default FlameWeeding;
